// MoffAPI(actionのtype, reducerのstate)
export const LOADING: string = 'LOADING';
export const SUCCESS: string = 'SUCCESS';
export const ERROR: string = 'ERROR';

export const FETCH_PATIENTS_SUCCESS: string = 'FETCH_PATIENTS_SUCCESS';
export const FETCH_DOCTORS_SUCCESS: string = 'FETCH_DOCTORS_SUCCESS';
export const FETCH_HOSPITALS_SUCCESS: string = 'FETCH_HOSPITALS_SUCCESS';
export const FETCH_DOCTORS_IN_HOSPITAL_SUCCESS: string = 'FETCH_DOCTORS_IN_HOSPITAL_SUCCESS';

export const FETCH_PATIENT_DETAILS_SUCCESS: string = 'FETCH_PATIENT_DETAILS_SUCCESS';
export const FETCH_HOSPITAL_DETAILS_SUCCESS: string = 'FETCH_HOSPITAL_DETAILS_SUCCESS';
export const FETCH_DOCTOR_DETAILS_SUCCESS: string = 'FETCH_DOCTOR_DETAILS_SUCCESS';

export const FETCH_PATIENT_DAYTRAININGLOGS_SUCCESS: string = 'FETCH_PATIENT_DAYTRAININGLOGS_SUCCESS';
export const FETCH_PATIENTS_DAYTRAININGLOGS_SUCCESS: string = 'FETCH_PATIENTS_DAYTRAININGLOGS_SUCCESS';

export const FETCH_INQUIRIES_SUCCESS: string = 'FETCH_INQUIRIES_SUCCESS';
export const FETCH_INQUIRY_SUCCESS: string = 'FETCH_INQUIRY_SUCCESS';

export const FETCH_USER_ID_SUCCESS: string = 'FETCH_USER_ID_SUCCESS';
export const FETCH_USER_NAME_SUCCESS: string = 'FETCH_USER_NAME_SUCCESS';

// add type
export const ADD_PATIENT_SUCCESS: string = 'ADD_PATIENT_SUCCESS';
export const ADD_DOCTOR_SUCCESS: string = 'ADD_DOCTOR_SUCCESS';
export const ADD_HOSPITAL_SUCCESS: string = 'ADD_HOSPITAL_SUCCESS';

// update type
export const UPDATE_PATIENT_SUCCESS: string = 'UPDATE_PATIENT_SUCCESS';
export const UPDATE_DOCTOR_SUCCESS: string = 'UPDATE_DOCTOR_SUCCESS';
export const UPDATE_HOSPITAL_SUCCESS: string = 'UPDATE_HOSPITAL_SUCCESS';
export const UPDATE_INQUIRY_SUCCESS: string = 'UPDATE_INQUIRY_SUCCESS';



// WEBPACK FOOTER //
// ./src/constants/MoffAPI.tsx